import {ILookupEntry} from 'shared/types/lookups';
import {performRequest} from 'shared/utils';

import {IReportTableColumn} from './dd-lookups-types';

export interface IFetchTableReportColumnsRequestArgs {
    templateCode: string;
}
export const fetchTableReportColumns = (
    params?: IFetchTableReportColumnsRequestArgs,
) => performRequest<IReportTableColumn[]>({
    url: '/table-reports/lookup/columns',
    method: 'GET',
    params: {
        ...params,
        sourceForBlock: 'TABLE',
    },
});

export const fetchTableReportFilterConditions = () => performRequest<ILookupEntry[]>({
    url: '/lookupValue/TABLE_REPORT_FILTER_VIEW',
    method: 'GET',
});
